module.exports = __webpack_public_path__ + "static/media/logo.12221bd5.svg";